import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

import Document from '../../../assets/images/svg-Docs.svg';

import { Container, Content } from './styles';

function Processo() {
  const documents = [
    { name: 'RG', id: 1 },
    { name: 'Carteira de identidade', id: 2 },
    { name: 'Passaporte', id: 3 },
  ];

  return (
    <Container>
      <p className="header">
        Administrador <span>Nome</span>
      </p>
      <Content>
        <div className="top-wrapper">
          <Link to="/gerenciamento-de-processos">
            <FiArrowLeft className="back-icon" />
          </Link>
        </div>
        <div className="process-wrapper">
          <p className="header">Processo</p>
          <div className="content">
            <table className="process">
              <tr>
                <th>Nome do proponente</th>
                <th>cpf</th>
                <th>Data</th>
                <th>Digitador 1</th>
                <th>Digitador 2</th>
                <th>Analista</th>
                <th>Status</th>
              </tr>
              <tr>
                <td id="process-text">Nome</td>
                <td id="process-text">123.456.789-10</td>
                <td id="process-text">25/05/2021</td>
                <td id="process-text">Nome</td>
                <td id="process-text">Nome</td>
                <td id="process-text">Nome</td>
                <td id="process-text">Aguardando</td>
              </tr>
            </table>
          </div>
        </div>
        <div className="bottom-wrapper">
          <div className="left-bottom">
            <div className="content" id="asw-response">
              <div className="asw-header">
                <p className="header">Perguntas e repostas do documento</p>
              </div>
              <div className="asw-doc">
                <button>Selecione um documento</button>
              </div>
            </div>
            <div className="content" id="analitics">
              <p>Em Breve</p>
            </div>
          </div>
          <div className="right-bottom">
            <div className="content" id="content-doc">
              <p className="header">Documentos</p>
              <div className="doc-wrapper">
                {documents.map((item) => {
                  return (
                    <div key={item.id}>
                      <img src={Document} alt="doc_placeholder" />
                      <p>{item.name}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </Content>
    </Container>
  );
}

export default Processo;
